export enum EBan {
  GET = 'ban/getBans',
  GET_MORE = 'ban/getMoreBans',
  GET_FILTERED = 'ban/getFilteredBans',
  GET_BY_ID = 'ban/getBanById',
  UNBAN_CHAT = 'ban/unbanChat',
}
